import { render, staticRenderFns } from "./client_list.vue?vue&type=template&id=676c15f6&"
import script from "./client_list.vue?vue&type=script&lang=js&"
export * from "./client_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports